import type {
  SettingMainItemsKeys,
  SettingsStateType,
} from '@carboncopyco/types/desktop/appSettings';
import { settingInitData } from './initData';

export const settingsState = {
  setItems: async (settings: SettingsStateType) =>
    window.dsDesktop.appSettings.setAppSettings(settings),
  getItems: async () => window.dsDesktop.appSettings.getAppSettings(),
  setItem: async (
    key: SettingMainItemsKeys,
    subKey: SettingsSubKeys,
    value: any
  ) => window.dsDesktop.appSettings.setSettingValue(key, subKey, value),
  getItem: async (key: SettingMainItemsKeys, subKey?: SettingsSubKeys) => {
    const res = await window.dsDesktop.appSettings.getAppSettings();
    const keyValue = res[key];
    if (keyValue) {
      if (subKey) {
        return keyValue[subKey];
      }
      return keyValue;
    }
    return null;
  },
  reset: async () =>
    window.dsDesktop.appSettings.setAppSettings(settingInitData),
};
